// Generated by Melange

import * as Belt__Belt_List from "melange.belt/belt_List.js";
import * as Buhta_core__GlobalStateContext from "../../../../../../packages/core/lib/GlobalStateContext.js";
import * as Buhta_landing__BlogMoreTags from "../../../components/blog/BlogMoreTags.js";
import * as Buhta_landing__I18n from "../../../util/i18n/I18n.js";
import * as Buhta_landing__Link from "../../../components/html/Link.js";
import * as Buhta_landing__Route from "../../../Route.js";
import * as Curry from "melange.js/curry.js";
import * as StaticAsset from "../../../../../../packages/util/lib/StaticAsset.js";
import * as Stdlib__List from "melange/list.js";
import * as ReactIntl from "react-intl";
import * as JsxRuntime from "react/jsx-runtime";

function BlogHero(Props) {
  let tags = Props.tags;
  let currentTag = Props.currentTag;
  let onSearch = Props.onSearch;
  let onTagClickOpt = Props.onTagClick;
  let searchField = Props.searchField;
  let onChangeSearchField = Props.onChangeSearchField;
  const onTagClick = onTagClickOpt !== undefined ? onTagClickOpt : (function (param) {
      
    });
  const currentRoute = Buhta_landing__Route.ofUrl(Buhta_landing__Route.useUrl(undefined));
  const state = Buhta_core__GlobalStateContext.useGlobalState(undefined);
  const deviceType = state.deviceType;
  const language = Buhta_landing__Route.getLanguage(undefined);
  const intl = ReactIntl.useIntl();
  const firstTagsNum = deviceType === "mobile" ? 2 : 5;
  const firstTags = Belt__Belt_List.keepWithIndex(tags, (function (_tag, idx) {
    return idx < firstTagsNum;
  }));
  const remainingTags = Belt__Belt_List.keepWithIndex(tags, (function (_tag, idx) {
    return idx >= firstTagsNum;
  }));
  const hidden = currentTag.id === "" ? "hidden" : "";
  let allActive;
  if (/* tag */ typeof currentRoute === "number" || typeof currentRoute === "string" || currentRoute.TAG !== /* Landing */ 0) {
    allActive = "";
  } else {
    let tmp = currentRoute._2;
    allActive = /* tag */ typeof tmp === "number" || typeof tmp === "string" || tmp.TAG !== /* Blog */ 1 ? "" : "bg-secondary";
  }
  return JsxRuntime.jsx("div", {
    children: JsxRuntime.jsxs("div", {
      children: [
        JsxRuntime.jsxs("h1", {
          children: [
            JsxRuntime.jsx(Buhta_landing__Link.make, {
              route: {
                TAG: /* Landing */ 0,
                _0: /* COUNTRY_KAZ */ 1,
                _1: language,
                _2: {
                  TAG: /* Blog */ 1,
                  _0: 0
                }
              },
              onLinkClicked: onTagClick,
              children: "Блог"
            }),
            JsxRuntime.jsx("span", {
              children: " / ",
              className: "" + hidden + " font-light"
            }),
            JsxRuntime.jsx("span", {
              children: currentTag.tag,
              className: "" + hidden
            })
          ],
          className: "h4 lg:h2 text-white"
        }),
        JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx(Buhta_landing__Link.make, {
                  route: {
                    TAG: /* Landing */ 0,
                    _0: /* COUNTRY_KAZ */ 1,
                    _1: language,
                    _2: {
                      TAG: /* Blog */ 1,
                      _0: 0
                    }
                  },
                  className: "text-white paragraph-small " + allActive + " px-4 py-2 border border-white/16 rounded",
                  onLinkClicked: onTagClick,
                  children: Buhta_landing__I18n.trans(intl, "blog_all")
                }),
                Belt__Belt_List.toArray(Stdlib__List.map((function (tag) {
                  const tagActive = currentTag.id === tag.id ? "bg-secondary" : "";
                  const Key = tag.id;
                  return JsxRuntime.jsx(Buhta_landing__Link.make, {
                    route: {
                      TAG: /* Landing */ 0,
                      _0: /* COUNTRY_KAZ */ 1,
                      _1: language,
                      _2: {
                        TAG: /* BlogSection */ 3,
                        _0: tag.title,
                        _1: 0
                      }
                    },
                    className: "text-white paragraph-small px-4 py-2 border border-white/16 rounded-sm ml-2 " + tagActive,
                    onLinkClicked: onTagClick,
                    children: tag.tag
                  }, Key);
                }), firstTags)),
                Stdlib__List.length(remainingTags) > 0 ? JsxRuntime.jsx(Buhta_landing__BlogMoreTags.make, {
                    currentTag: currentTag,
                    tags: remainingTags,
                    onTagClick: onTagClick
                  }) : null
              ],
              className: "flex mt-4 lg:mt-0"
            }),
            JsxRuntime.jsxs("form", {
              children: [
                JsxRuntime.jsx("img", {
                  alt: "search bold",
                  src: StaticAsset.src("/static/icons/search-bold.svg")
                }),
                JsxRuntime.jsx("input", {
                  className: "paragraph-small text-black-landing ml-1 placeholder-gray-landing w-full",
                  placeholder: Buhta_landing__I18n.trans(intl, "blog_search"),
                  type: "text",
                  value: searchField,
                  onChange: (function (ev) {
                    ev.preventDefault();
                    Curry._1(onChangeSearchField, ev.target.value);
                  })
                })
              ],
              className: "lg:mr-8 lg:w-80 bg-white flex items-center p-2 rounded",
              onSubmit: (function (ev) {
                ev.preventDefault();
                Curry._1(onSearch, searchField);
              })
            })
          ],
          className: "mt-4 lg:mt-10 flex flex-col-reverse lg:flex-row justify-between"
        })
      ],
      className: "px-6 sm:px-48 lg:px-0 lg:w-304 flex m-auto flex-col"
    }),
    className: "bg-primary-variant pt-10 lg:pt-20 pb-6"
  });
}

const make = BlogHero;

export {
  make,
}
/* Buhta_core__GlobalStateContext Not a pure module */
